var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "portlet-body", staticStyle: { height: "auto" } },
    [
      _c(
        "div",
        {},
        [
          _c(
            "contabil-balancete-pivot-grid",
            { attrs: { title: "Balancete" } },
            [
              _c(
                "template",
                { slot: "filtro" },
                [
                  _c("contabil-balancete-filtro", {
                    attrs: {
                      "color-selected": "blue",
                      "color-deselected": "white",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }